import { render, staticRenderFns } from "./SettingsTemplate.vue?vue&type=template&id=7a4c9670&"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js&"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports